// User-facing copy: club. Moved from the web app (components/Noticeboard.tsx, components/PublicClub.tsx, pages/club/ClubLayout.tsx, pages/club/ClubSettingsPage.tsx, pages/club/ClubTab.tsx, pages/club/MembersPage.tsx) so the web and the app say the same thing.
// Strings that take values are functions. Generated keys; rename freely, they're just names.
/** components/Noticeboard.tsx */
export const noticeboard = {
    noticeboard: "Noticeboard",
    anythingThatIsnT: "Anything that isn't about the book",
    noSpoilersHereTalk: (title) => `No spoilers here. Talk about ${title} in `,
    talk: "Talk",
    whereItStaysHidden: ", where it stays hidden until people get there.",
    bookTalkGoesIn: "Book talk goes in ",
    nothingOnTheNoticeboard: "Nothing on the noticeboard yet",
    welcomePeopleSortOut: "Welcome people, sort out meetups, share what else you're reading. Book talk goes in Talk.",
    loading: "Loading…",
    olderPosts: "Older posts",
    pinnedNotice: "Pinned notice",
    pinnedBy: (x, dayShort, x2) => `Pinned by ${x} · ${dayShort}${x2}`,
    you: "you",
    anAdmin: "an admin",
    until: (dayShort) => ` · until ${dayShort}`,
    you2: "You",
    new: " · new",
    reply: "reply",
    replies: "replies",
    reply2: "Reply",
    thisPostWasDeleted: "This post was deleted",
    edited: " · edited",
    new2: "New",
    left: "left",
    newReply: "New reply",
    hideReplies: "Hide replies",
    your: "your",
    s: (name) => `${name}'s`,
    movedPostTo: (x, whose, title) => `${x} moved ${whose} post to ${title} · `,
    movedTo: (x, title) => `${x} moved to ${title} · `,
    yourPost: "Your post",
    aPostBy: (name) => `A post by ${name}`,
    theEnd: "the end",
    postSomethingForThe: "Post something for the club…",
    postSomethingForThe2: "Post something for the club",
    post: "Post",
    save: "Save",
    cancel: "Cancel",
    more: "More",
    replyTo: (x) => `Reply to ${x}`,
    yourself: "yourself",
    unpin: "Unpin",
    pinToTheTop: "Pin to the top",
    moveTo: (title) => `Move to ${title}`,
    edit: "Edit",
    delete: "Delete",
    close: "Close",
    pinThisToThe: "Pin this to the top?",
    thisReplaces: (excerpt) => `This replaces “${excerpt}”.`,
    unpinItOn: "Unpin it on ",
    optional: "(optional)",
    pinThisInstead: "Pin this instead",
    pinIt: "Pin it",
    deleteThis: (x, x2) => `Delete this ${x}?${x2}`,
    post2: "post",
    its: (plural) => ` Its ${plural}.`,
    replyStays: "reply stays",
    repliesStay: "replies stay",
    keep: "Keep",
    they: "they",
    moveThisTo: (title) => `Move this to ${title}?`,
    landsAt: "Lands at",
    whereItLands: "Where it lands",
    where: (x) => `Where ${x}`,
    youWere: "you were",
    was: (name) => `${name} was`,
    through: (name) => `Through ${name}`,
    p: (page) => `p. ${page}`,
    later: "Later",
    page: "Page",
    percent: "Percent",
    page2: "page",
    useIt: "Use it",
    pickSomewherePast: (landing) => `Pick somewhere past ${landing}.`,
    theEnd2: "The end",
    sealedUntilEachReader: "sealed until each reader finishes",
    recordedAnyProgressWhen: (x, they) => `${x} recorded any progress when ${they} posted, so it goes into the book's discussion sealed until each reader finishes.`,
    youHadnT: "You hadn't",
    hadnT: (name) => `${name} hadn't`,
    thatSSpotWhen: (who, they) => `That's ${who} spot when ${they} posted, so people who aren't there yet won't see it.`,
    sealedPastSpotWhen: (who, they, landing) => `Sealed past ${who} spot when ${they} posted (${landing}), for people who aren't there yet.`,
    thisCanTBe: (x) => `${x} This can't be undone.`,
    withItEachAt: (x) => ` ${x} with it, each at where its author was.`,
    theReplyMoves: "The reply moves",
    repliesMove: "Replies move",
    moveIt: "Move it",
    replyTo2: (to) => `Reply to ${to}…`,
    replyTo3: (to) => `Reply to ${to}`,
    noRepliesYet: "No replies yet.",
};
/** components/PublicClub.tsx */
export const publicClub = {
    aboutEveryWeek: "About every week",
    aboutEveryTwoWeeks: "About every two weeks",
    aboutEveryThreeWeeks: "About every three weeks",
    aboutEveryMonth: "About every month",
    aboutEveryWeeks: (round) => `About every ${round} weeks`,
    anAdminPicks: "An admin picks",
    theClubVotes: "The club votes",
    membersTakeTurns: "Members take turns",
    and: (join, x) => `${join} and ${x}`,
    signInToJoin: "Sign in to join",
    pagematesHome: "Pagemates home",
    signIn: "Sign in",
    findAClub: "Find a club",
    openAnyoneCanJoin: "Open · anyone can join",
    requestToJoin: "Request to join",
    since: (names, x, memberCount, x2, monthYear) => `${names}  ${x} · ${memberCount}  ${x2} · since ${monthYear}`,
    runsIt: "runs it",
    runIt: "run it",
    member: "member",
    members: "members",
    readingNow: "Reading now",
    pages: (pages) => ` · ${pages} pages`,
    theShelfSoFar: "The shelf so far",
    howThisClubWorks: "How this club works",
    pace: "Pace",
    aboutPagesADay: (x, usualPace) => `${x}about ${usualPace} pages a day`,
    picking: "Picking",
    meets: "Meets",
    spoilers: "Spoilers",
    hiddenUntilYouGet: "Hidden until you get there",
    notHidden: "Not hidden",
    openTheClub: "Open the club",
    joinTheClub: "Join the club",
    requested: "Requested",
    anAdminWillDecide: "An admin will decide. You can cancel any time.",
    cancelRequest: "Cancel request",
    notAccepted: "Not accepted",
    youCanAskAgain: (day) => `You can ask again after ${day}.`,
    findAnotherClub: "Find another club",
    askToJoin: "Ask to join",
    close: "Close",
    join: (name) => `Join ${name}?`,
    membersWillSeeYour: "Members will see your name, photo and reading progress.",
    joining: "Joining…",
    join2: "Join",
    notNow: "Not now",
    askToJoin2: (name) => `Ask to join ${name}`,
    aNoteForThe: "A note for the admins (optional)",
    whyThisClubIn: "Why this club, in a line or two.",
    ifYouReLet: "If you're let in, members will see your name, photo and reading progress.",
    sending: "Sending…",
    sendRequest: "Send request",
    askingToJoin: "Asking to join ",
    letIn: "Let in",
    decline: "Decline",
    blocked: (length) => `Blocked · ${length}`,
    since2: (day) => `· since ${day}`,
    unblock: "Unblock",
    unblockingDoesnTAdd: "Unblocking doesn't add anyone back. They can return by invite, or join or ask like anyone else.",
};
/** pages/club/ClubLayout.tsx */
export const layout = {
    peopleAreAskingTo: "People are asking to join",
    newOnTheNoticeboard: "New on the noticeboard",
    clubSections: "Club sections",
    needsYourAnswer: "Needs your answer",
    allClubs: "All clubs",
    yourProfile: "Your profile",
    switchClub: "Switch club",
    finished: "finished",
    nothingOnTheNightstand: "Nothing on the nightstand yet",
    newMessages: (unreadMessages) => `${unreadMessages} new messages`,
    youReNoLonger: "You're no longer a member of this club",
    thisClubIsPrivate: "This club is private, or the link is wrong",
    findAClub: "Find a club",
    goToYourClubs: "Go to your clubs",
    toComeBackAsk: "To come back, ask a member for an invite link.",
    askAMemberFor: "Ask a member for an invite link.",
    reading: "Reading",
    talk: "Talk",
    shelf: "Shelf",
    meeting: "Meeting",
    club: "Club",
};
/** pages/club/ClubSettingsPage.tsx */
export const settings = {
    club: "Club",
    settings: "Settings",
    theClub: "The club",
    whatPeopleSeeWhen: "What people see when they find your club or open an invite.",
    clubName: "Club name",
    oneLineAboutThe: "One line about the club",
    twoReadersOneLamp: "Two readers, one lamp.",
    howThisClubWorks: "How this club works",
    howOftenYouMeet: "How often you meet, whether unfinished readers come, what you tend to read.",
    shownOnTheClub: "Shown on the Club tab and on the invite page.",
    whoCanFindThis: "Who can find this club",
    whoCanSeeThe: "Who can see the club and how people join. Only the owner can change this.",
    readingTogether: "Reading together",
    howTheClubShares: "How the club shares the book when everyone reads at their own speed.",
    usualPace: "Usual pace",
    roughlyHowManyPages: "Roughly how many pages a day the club reads. People see it before they join, and it helps plan how far each meeting gets.",
    hideSpoilersInTalk: "Hide spoilers in Talk",
    everyCommentIsMarked: "Every comment is marked with how far its writer had read. You only see the ones from up to where you are, and the rest appear as you catch up. When off, everyone sees everything.",
    askersCanReadAnswers: "Askers can read answers early",
    ifSomeoneAnswersYour: "If someone answers your question from further on in the book, you can choose to read it now. When off, it waits until you reach that part. Nothing else opens early.",
    pickingTheNextBook: "Picking the next book",
    howTheClubDecides: "How the club decides what to read next.",
    howItGetsPicked: "How it gets picked",
    whicheverYouChooseEveryone: "Whichever you choose, everyone can still suggest books.",
    howTheNextBook: "How the next book gets picked",
    adminsPick: "Admins pick",
    vote: "Vote",
    takeTurns: "Take turns",
    anAdminChoosesThe: "An admin chooses the next book from the shortlist.",
    membersVoteOnThe: "Members vote on the shortlist. An admin opens and closes the vote from the Shelf.",
    membersTakeTurnsChoosing: "Members take turns choosing, in the order they joined. Whoever's turn it is starts the next book.",
    countedBy: "Counted by",
    rankedEveryonePutsThe: "Ranked: everyone puts the books in order, and first choices count most. Approval: everyone ticks every book they'd happily read, which is quicker in a big club.",
    howAVoteIs: "How a vote is counted",
    ranked: "Ranked",
    approval: "Approval",
    withMembersTakingTurns: (memberCount) => `With ${memberCount} members taking turns, it'll be a long while before everyone gets a pick. A vote may suit an open club this size.`,
    theShortlistIsMade: "The shortlist is made of",
    theShortlistCalledOn: (x) => `The shortlist, called On deck on the Shelf, is what the club picks the next book from. ${x}`,
    rightNowItS: "Right now it's the suggestions the most members want to read; admins can pin others in.",
    rightNowAdminsChoose: "Right now admins choose it by pinning suggestions.",
    mostWanted: "Most wanted",
    admins: "Admins",
    shortlistSize: "Shortlist size",
    howManyBooksAre: "How many books are on it at once.",
    books: "books",
    suggestions: "Suggestions",
    booksMembersPutForward: "Books members put forward for the club to read someday.",
    whoCanSuggest: "Who can suggest",
    whoCanAddA: "Who can add a book to the club's suggestions. Everyone can still mark one Want to read.",
    everyone: "Everyone",
    limitPerMember: "Limit per member",
    capHowManySuggestions: "Cap how many suggestions each member can have at once, so a few people can't fill the list. When off, there's no limit.",
    each: "each",
    limitSuggestionsPerMember: "Limit suggestions per member",
    tidyAwayOldSuggestions: "Tidy away old suggestions",
    suggestionsNobodyHasShown: "Suggestions nobody has shown new interest in for a while move to a Past list, out of the way. Nothing is deleted: anyone can bring one back by marking it Want to read, and whoever suggested a book hears two weeks before it moves.",
    alwaysKeepTheTop: "Always keep the top",
    mostWantedHoweverOld: "most wanted, however old",
    tidyTheRestAfter: "Tidy the rest after",
    withNobodyNewWanting: "with nobody new wanting to read it",
    days: "days",
    notSet: "Not set",
    edit: (toLowerCase) => `Edit ${toLowerCase}`,
    save: "Save",
    cancel: "Cancel",
    private: "Private",
    onlyPeopleWithAn: "Only people with an invite link can join. The club doesn't appear anywhere.",
    requestToJoin: "Request to join",
    listedInTheDirectory: "Listed in the Directory. People ask to join and an admin decides.",
    open: "Open",
    listedInTheDirectory2: "Listed in the Directory. Anyone signed in can join straight away.",
    mode: "Mode",
    onlyTheOwnerCan: "Only the owner can change this.",
    addAOneLine: "Add a one-line description under The club first: it's what people see in the Directory.",
    inviteLinksWorkIn: "Invite links work in every mode.",
    confirm: "Confirm",
    makePrivate: (name) => `Make ${name} private?`,
    itLeavesTheDirectory: (x) => `It leaves the Directory straight away, and its page shows as private.${x} Members stay.`,
    theWaitingForAn: (waiting, x) => ` The ${waiting} ${x} waiting for an answer will be declined.`,
    person: "person",
    people: "people",
    switchToOpen: "Switch to Open?",
    anyoneSignedInWill: "Anyone signed in will be able to join straight away.",
    the: " The ",
    waitingForAnAnswer: " waiting for an answer will be let in now.",
    makeOpen: (name) => `Make ${name} open?`,
    listInTheDirectory: (name) => `List ${name} in the Directory?`,
    peopleWhoArenT: (x) => `${x} People who aren't members will see:`,
    itAppearsInThe: "It appears in the Directory right away, and anyone signed in can join.",
    itAppearsInThe2: "It appears in the Directory right away, and people can ask to join.",
    nameDescriptionAndHow: "Name, description and how the club works",
    theCurrentBookAnd: "The current book and the last few on the shelf",
    usualPaceHowThe: "Usual pace, how the next book is picked, and how often you meet",
    genresWhenTheClub: "Genres, when the club started, and how many members",
    theOwnerSAnd: "The owner's and admins' names and photos",
    neverShownTalkThe: "Never shown: Talk, the noticeboard, anyone's progress, meeting place and date, suggestions, ratings, or the member list.",
    makeItPrivate: "Make it private",
    switchAndLetIn: (waiting) => `Switch and let ${waiting} in`,
    switchToOpen2: "Switch to Open",
    makeItOpen: "Make it open",
    listIt: "List it",
    saved: "Saved",
    link: "Link",
    clubs: (origin) => `${origin}/clubs/`,
    changeTheLink: "Change the link",
    copy: "copy",
    lowercaseLettersDigitsAnd: "Lowercase letters, digits and hyphens. The old link stops working once you change it.",
    theClubIsPublic: "The club is public, so links people have shared will stop working.",
    yourMembership: "Your membership",
    youOwnThisClub: "You own this club. Hand it on before you leave.",
    leavingKeepsYourComments: "Leaving keeps your comments and progress.",
    transferOwnership: "Transfer ownership",
    youStayOnAs: "You stay on as an admin. Required before you can leave.",
    newOwner: "New owner",
    chooseAMember: "Choose a member",
    noOtherMembersYet: "No other members yet",
    transfer: "Transfer",
    deleteThisClub: "Delete this club",
    deleteForEveryoneBooks: (name) => `Delete ${name} for everyone? Books, progress and the whole discussion go with it. There is no undo.`,
    leaveThisClub: "Leave this club",
    yourCommentsAndProgress: "Your comments and progress stay, marked as a former member. You'd need a new invite to come back.",
    orBlank: ", or blank",
};
/** pages/club/ClubTab.tsx */
export const tab = {
    inviteSomeone: "Invite someone",
    clubSettings: "Club settings",
    sayHowThisClub: "Say how this club works, in ",
    howOftenYouMeet: ": how often you meet, whether unfinished readers come.",
    reads: "Reads",
    fromTheShelf: "From the shelf",
    hosting: (name) => ` · ${name} hosting`,
    yourMembership: "Your membership",
    inviteLinks: "Invite links",
    done: "Done",
    linksLast7Days: "Links last 7 days. Anyone with one can join, unless it's single-use.",
    expires: (toLocaleDateString, x) => `Expires ${toLocaleDateString}${x}`,
    singleUse: " · single-use",
    used: (uses) => ` · used ${uses}×`,
    copied: "Copied",
    copy: "Copy",
    revokeInvite: "Revoke invite",
    newInviteLink: "New invite link",
    yourClubJustReached: "Your club just reached 10 members",
    aBusyShelfIs: "A busy shelf is easier with a few limits. Approval voting is quicker for big groups, and a cap on suggestions per member keeps the list fair. Nothing changes unless you turn it on.",
    reviewShelfSettings: "Review shelf settings",
    notNow: "Not now",
    singleUse2: " single-use",
};
/** pages/club/MembersPage.tsx */
export const members = {
    club: "Club",
    members: "Members",
    findAMember: "Find a member",
    show: "Show",
    sort: "Sort",
    name: "Name",
    newest: "Newest",
    recentlyActive: "Recently active",
    nobodyMatches: "Nobody matches.",
    showMoreLeft: (min, x) => `Show ${min} more · ${x} left`,
};
//# sourceMappingURL=club.js.map